import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../components/ui/table";
import type { ParsedColumn } from "../../../../../models/audit/sampleUpload";

interface PreviewRowsTableProps {
  columns: ParsedColumn[];
  previewRows: Array<Record<string, string | number | null>>;
  totalRowCount: number;
}

export function PreviewRowsTable({
  columns,
  previewRows,
  totalRowCount,
}: PreviewRowsTableProps) {
  return (
    <div className="space-y-3">
      <div>
        <h3 className="text-xs font-semibold text-stone-500 uppercase tracking-wide">
          Preview (First {previewRows.length} Rows)
        </h3>
        <p className="text-xs text-stone-400 mt-1">
          {totalRowCount} total rows in file
        </p>
      </div>

      <div className="border rounded-lg overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {columns.map((column) => (
                <TableHead
                  key={column.columnIndex}
                  className="whitespace-nowrap"
                >
                  {column.columnName}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {previewRows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map((column) => (
                  <TableCell
                    key={column.columnIndex}
                    className="whitespace-nowrap"
                  >
                    {formatCellValue(findRowValue(row, column.columnName))}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

function findRowValue(
  row: Record<string, string | number | null>,
  columnName: string,
): string | number | null {
  // Direct lookup first
  if (columnName in row) {
    return row[columnName];
  }
  // Handle BOM characters and whitespace differences in CSV column names
  const normalizedColumnName = columnName.trim().toLowerCase();
  for (const key of Object.keys(row)) {
    // Remove BOM and normalize whitespace
    const normalizedKey = key
      .replace(/^\uFEFF/, "")
      .trim()
      .toLowerCase();
    if (normalizedKey === normalizedColumnName) {
      return row[key];
    }
  }
  return null;
}

function formatCellValue(value: string | number | null): string {
  if (value === null || value === undefined) {
    return "-";
  }
  if (typeof value === "number") {
    return value.toLocaleString();
  }
  return String(value);
}
